import * as PIXI from 'pixi.js';
import { ALL_BITMAP_TEXT_STYLE_PROPERTIES } from '../types/bitmapTextTypes';
/**
 * Calculate the TextMetrics if not already set.
 */
export function withTextMetrics(textProperties) {
    const { label, textStyle } = textProperties;
    if (textProperties.textMetrics) {
        // textMetrics already calculated, nothing to do
        return { label, textStyle, textMetrics: textProperties.textMetrics };
    }
    const newTextMetrics = PIXI.TextMetrics.measureText(label, textStyle);
    return { label, textStyle, textMetrics: newTextMetrics };
}
export function withBitmapTextMetrics({ text, bitmapTextStyleType }, styleOptions = {}) {
    return { text, bitmapTextStyleType, dimensions: getBitmapTextDimensions(text, bitmapTextStyleType, styleOptions) };
}
function createTextStyleWithOptions(bitmapTextStyleType, { maxWidth, letterSpacing } = {}) {
    const style = { fontName: bitmapTextStyleType };
    if (maxWidth !== undefined) {
        style.maxWidth = maxWidth;
    }
    if (letterSpacing !== undefined) {
        style.letterSpacing = letterSpacing;
    }
    return style;
}
export function getBitmapTextDimensions(text, bitmapTextStyleType, styleOptions = {}) {
    const bitmapText = new PIXI.BitmapText(text, createTextStyleWithOptions(bitmapTextStyleType, styleOptions));
    const bounds = bitmapText.getLocalBounds();
    return {
        w: bounds.width,
        h: bounds.height + (ALL_BITMAP_TEXT_STYLE_PROPERTIES[bitmapTextStyleType].heightAdjustmentPx || 0)
    };
}
export function getBitmapTextMetricsWithTruncation(text, bitmapTextStyleType, availableWidthPx, styleOptions = {}) {
    if (!text) {
        return;
    }
    const suffix = '…';
    let substring = text;
    let currSuffix = '';
    // eslint-disable-next-line no-constant-condition
    while (true) {
        const currText = `${substring}${currSuffix}` || suffix;
        const dimensions = getBitmapTextDimensions(currText, bitmapTextStyleType, styleOptions);
        if (currText.length <= 1 || dimensions.w <= availableWidthPx) {
            return {
                text: currText,
                dimensions
            };
        }
        // need to truncate
        if (substring.length) {
            substring = substring.substring(0, substring.length - 1);
        }
        currSuffix = currSuffix || suffix;
    }
}
